
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import styled from "styled-components"
import SmallSpinner from "../shared/spinners/SmallSpinner"
import question from "../../images/svg/question.svg"
import Button from "../shared/Button"
import Btn from "../shared/button/Btn"
import { coopUpdateUyeDoc } from "../../features/uyelerAraclar/uyelerAraclarSlice"

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    color: ${({theme}) => theme.mainTextColor};

    .top-container{
        width: 100%;

        h4{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);
        }
    }

    .belge-list{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 35px;
        width: 100%;
        padding: 20px 0;
        height: 500px;
        overflow: auto;
        border-top: 1px solid ${({theme})=> theme.mainBorderColor};

        &::-webkit-scrollbar {
            width: 0;
            width: 8px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({theme})=> theme.scrollThumbColor};
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }
        
        .belge-item{
            display: flex;
            flex-direction: column;
            width: 31%;
            height: 420px;  
            border-radius: 10px;
            padding: 0 20px;
            background-color: ${({ theme }) => theme.secondaryBgColor};

            .belge-top{
                width: 100%;
                height: 40px;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 10px 0;
                font-weight: var(--font-weight-lg);
                border-bottom: 1px solid ${({theme})=> theme.mainBorderColor};

            }
            .belge-img{
                width: 100%;
                height: calc(100% - 100px);
                object-fit: cover;
            }

            .belge-bottom{
                width: 100%;
                height: 60px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px solid ${({theme})=> theme.mainBorderColor};


                .file-input-label{
                    width: auto;
                    padding: 0 15px;
                    /* line-height: 40px; */
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 40px;
                    color: ${({ theme }) => theme.mainTextColor};
                    border-radius: 10px;
                    font-weight: var(--font-weight-lg);
                    font-size: 16px;
                    border: 1px solid;
                    cursor: pointer;
                    border-color: ${({ theme }) => theme.contrastColor};
                }
                .file-name{
                    font-weight: var(--font-weight-md);
                    font-size: 14px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    -webkit-line-clamp: 1;
                    width: 100px;
                    margin-inline: 5px;
                }

                .file-input{
                    display: none;
                }

            }
        }
    }
`

const KooperatifUyeDoc = () => {
    const { uyeItemData, isLoadingUyeDoc, isSuccessUyeDoc } = useSelector(state => state.uyelerAraclar)
    const dispatch = useDispatch()

    const [kimlik, setKimlik] = useState("")
    const [src, setSrc] = useState("")
    const [ehliyet, setEhliyet] = useState("")
    const [referansFaturasi, setReferansFaturasi] = useState("")
    const [vergiLevhasi, setVergiLevhasi] = useState("")
    const [diger1, setDiger1] = useState("")
    const [diger2, setDiger2] = useState("")

    const handleKimlikSubmit = ()=> {
        if(kimlik){
            const updatedData = {
                userName: uyeItemData.phoneNumber,
                documentType: "kimlik",
                imageFile: kimlik
            }
            dispatch(coopUpdateUyeDoc(updatedData))
        }
    }

    const handleEhliyetSubmit = ()=>{
        if(ehliyet){
            const updatedData = {
                userName: uyeItemData.phoneNumber,
                documentType: "ehliyet",
                imageFile: ehliyet
            }
            dispatch(coopUpdateUyeDoc(updatedData))
        }
    }

    const handleSrcSubmit =()=> {
        if(src){
            const updatedData = {
                userName: uyeItemData.phoneNumber,
                documentType: "src",
                imageFile: src
            }
            dispatch(coopUpdateUyeDoc(updatedData))
        }
    }

    const handleReferansFaturasiSubmit =()=> {
        if(referansFaturasi){
            const updatedData = {
                userName: uyeItemData.phoneNumber,
                documentType: "fatura",
                imageFile: referansFaturasi
            }
            dispatch(coopUpdateUyeDoc(updatedData))
        }
    }

    const handleVergiLevhasiSubmit = ()=>{
        if(vergiLevhasi){
            const updatedData = {
                userName: uyeItemData.phoneNumber,
                documentType: "vergiLevhası",
                imageFile: vergiLevhasi
            }
            dispatch(coopUpdateUyeDoc(updatedData))
        }
    }
    
    const handleDiger1Submit =()=> {
        if(diger1){
            const updatedData = {
                userName: uyeItemData.phoneNumber,
                documentType: "diğer-1",
                imageFile: diger1
            }
            dispatch(coopUpdateUyeDoc(updatedData))
        }
    }

    const handleDiger2Submit = ()=>{
        if(diger2){
            const updatedData = {
                userName: uyeItemData.phoneNumber,
                documentType: "diğer-2",
                imageFile: diger2
            }
            dispatch(coopUpdateUyeDoc(updatedData))
        }
    }

    useEffect(() => {
        if(isSuccessUyeDoc === true){
            setDiger2("")
            setDiger1("")
            setVergiLevhasi("")
            setReferansFaturasi("")
            setEhliyet("")
            setSrc("")
            setKimlik("")
        }
    },[isSuccessUyeDoc])

{/* <SmallSpinner size={"20px"} color={"#fff"} bgColor={"##E85446"}/> */}
  return (
    <Container>
        <div className="top-container">
            <h4>Adı Soyadı: {uyeItemData.adSoyadUnvan}</h4>
        </div>
            <div className="belge-list">
                <div className="belge-item">
                    <div className="belge-top">Kimlik</div>
                    <img src={(kimlik && URL.createObjectURL(kimlik)) || (uyeItemData.kimlik ? `${process.env.REACT_APP_API_IMG_URI}${uyeItemData.kimlik}` : question)} className="belge-img" alt="kimlik" />
                    <div className="belge-bottom">
                        <label className="file-input-label" htmlFor="kimlikFile">Belge Seç</label>
                        <div className="file-name">{kimlik?.name || "Belge Seçin"}</div>
                        <input type="file" id="kimlikFile" className='file-input' onChange={(e) => setKimlik(e.target.files[0])} />
                        {
                            kimlik &&
                            <Btn handleClick={handleKimlikSubmit} bgColor="#E85446" color="#fff" padding="10px" >{isLoadingUyeDoc ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"##E85446"}/> : "Kimlik Yükle"}</Btn>
                        }
                    </div>
                </div>
                <div className="belge-item">
                    <div className="belge-top">Ehliyet</div>
                    <img src={ (ehliyet && URL.createObjectURL(ehliyet)) || (uyeItemData.ehliyetPhoto ? `${process.env.REACT_APP_API_IMG_URI}${uyeItemData.ehliyetPhoto}`: question)} className="belge-img" alt="ehliyet" />
                    <div className="belge-bottom">
                        <label className="file-input-label" htmlFor="ehliyetFile">Belge Seç</label>
                        <div className="file-name">{ehliyet?.name || "Belge Seçin"}</div>
                        <input type="file" id="ehliyetFile" className='file-input' onChange={(e) => setEhliyet(e.target.files[0])} />
                        {
                            ehliyet &&
                            <Btn handleClick={handleEhliyetSubmit} bgColor="#E85446" color="#fff" padding="10px" >{isLoadingUyeDoc ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"##E85446"}/> : "Ehliyet Yükle"}</Btn>
                        }
                    </div>
                </div>
                <div className="belge-item">
                    <div className="belge-top">SRC Belgesi</div>
                    <img src={ (src && URL.createObjectURL(src)) || (uyeItemData.srcPhoto ? `${process.env.REACT_APP_API_IMG_URI}${uyeItemData.srcPhoto}`: question)} className="belge-img" alt="ehliyet" />
                    <div className="belge-bottom">
                        <label className="file-input-label" htmlFor="srcFile">Belge Seç</label>
                        <div className="file-name">{src?.name || "Belge Seçin"}</div>
                        <input type="file" id="srcFile" className='file-input' onChange={(e) => setSrc(e.target.files[0])} />
                        {
                            src &&
                            <Btn handleClick={handleSrcSubmit} bgColor="#E85446" color="#fff" padding="10px" >{isLoadingUyeDoc ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"##E85446"}/> : "SRC Belgesi Yükle"}</Btn>
                        }
                    </div>
                </div>
                <div className="belge-item">
                    <div className="belge-top">Referans Faturası</div>
                    <img src={ (referansFaturasi && URL.createObjectURL(referansFaturasi)) || (uyeItemData.referansFaturası ? `${process.env.REACT_APP_API_IMG_URI}${uyeItemData.referansFaturası}`: question)} className="belge-img" alt="referansFaturası" />
                    <div className="belge-bottom">
                        <label className="file-input-label" htmlFor="referansFaturasiFile">Belge Seç</label>
                        <div className="file-name">{referansFaturasi?.name || "Belge Seçin"}</div>
                        <input type="file" id="referansFaturasiFile" className='file-input' onChange={(e) => setReferansFaturasi(e.target.files[0])} />
                        {
                            referansFaturasi &&
                            <Btn handleClick={handleReferansFaturasiSubmit} bgColor="#E85446" color="#fff" padding="10px" >{isLoadingUyeDoc ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"##E85446"}/> : "Referans Faturası Yükle"}</Btn>
                        }
                    </div>
                </div>
                <div className="belge-item">
                    <div className="belge-top">Vergi Levhası</div>
                    <img src={(vergiLevhasi && URL.createObjectURL(vergiLevhasi)) || (uyeItemData.vergiLevhası ? `${process.env.REACT_APP_API_IMG_URI}${uyeItemData.vergiLevhası}`: question)} className="belge-img" alt="vergiLevhası" />
                    <div className="belge-bottom">
                        <label className="file-input-label" htmlFor="vergiLevhasiFile">Belge Seç</label>
                        <div className="file-name">{vergiLevhasi?.name || "Belge Seçin"}</div>
                        <input type="file" id="vergiLevhasiFile" className='file-input' onChange={(e) => setVergiLevhasi(e.target.files[0])} />
                        {
                            vergiLevhasi &&
                            <Btn handleClick={handleVergiLevhasiSubmit} bgColor="#E85446" color="#fff" padding="10px" >{isLoadingUyeDoc ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"##E85446"}/> : "Vergi Levhası Yükle"}</Btn>
                        }
                    </div>
                </div>
                <div className="belge-item">
                    <div className="belge-top">Diğer-1</div>
                <img src={(diger1 && URL.createObjectURL(diger1)) || (uyeItemData.diger1 ? `${process.env.REACT_APP_API_IMG_URI}${uyeItemData.diger1}`: question)} className="belge-img" alt="diger1" />
                <div className="belge-bottom">
                        <label className="file-input-label" htmlFor="diger1File">Belge Seç</label>
                        <div className="file-name">{diger1?.name || "Belge Seçin"}</div>
                        <input type="file" id="diger1File" className='file-input' onChange={(e) => setDiger1(e.target.files[0])} />
                        {
                            diger1 &&
                            <Btn handleClick={handleDiger1Submit} bgColor="#E85446" color="#fff" padding="10px" >{isLoadingUyeDoc ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"##E85446"}/> : "Diğer-1 Yükle"}</Btn>
                        }
                    </div>
                </div>
                <div className="belge-item">
                    <div className="belge-top">Diğer-2</div>
                    <img src={(diger2 && URL.createObjectURL(diger2)) ||( uyeItemData.diger2 ? `${process.env.REACT_APP_API_IMG_URI}${uyeItemData.diger2}`: question)} className="belge-img" alt="diger2" />
                    <div className="belge-bottom">
                        <label className="file-input-label" htmlFor="diger2File">Belge Seç</label>
                        <div className="file-name">{diger2?.name || "Belge Seçin"}</div>
                        <input type="file" id="diger2File" className='file-input' onChange={(e) => setDiger2(e.target.files[0])} />
                        {
                            diger2 &&
                            <Btn handleClick={handleDiger2Submit} bgColor="#E85446" color="#fff" padding="10px" >{isLoadingUyeDoc ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"##E85446"}/> : "Diğer-2 Yükle"}</Btn>
                        }
                    </div>
                </div>
            </div>
    </Container>
  )
}

export default KooperatifUyeDoc